import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const HEADERBIGLOGOBLOCK_LEGACY_FIELD_ORDER = [
  "logo",
  "background_color",
  "is_static",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  headerBigLogoBlockDescriptor: _generatedHeaderBigLogoBlockDescriptor,
  headerBigLogoBlockBlocDefinition,
  headerBigLogoBlockDashboardLayout,
  headerBigLogoBlockConfig,
  headerBigLogoBlockResolveConfig,
  headerBigLogoBlockProperties,
} = doodBlockConfig(
  {
    name: "Header - Big logo",
    componentType: "HeaderBigLogoBlockComponent",
    category: "navigation",
    description: "Header - Big logo.",
    keywords: [],
    allowedIn: [
      { bloc: "HeaderBlockComponent", slot: "left_blocks" },
      { bloc: "HeaderBlockComponent", slot: "right_blocks" },
    ],
    sharedFields: {},
  },

  () => ({
    logo: propertyValue({
      type: "image",
      value: "",
      options: {
        label: "pages.blocks.header-big-logo.logo.label",
        help: "pages.blocks.header-big-logo.logo.help",
      },
    }),
    background_color: propertyValue({
      type: "color",
      value: { type: "hex", value: "#FFFFFF" },
      options: {
        label: "pages.blocks.header-big-logo.background-color.label",
      },
    }),
    is_static: propertyValue({
      type: "checkbox",
      value: false,
      options: {
        label: "pages.blocks.header-big-logo.is-static.label",
        help: "pages.blocks.header-big-logo.is-static.help",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.header-big-logo.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.header-big-logo.fieldset.logo.label",
            fields: ["logo", "background_color", "is_static"],
          },
        ],
      },
    ],
  }),
);

export function headerBigLogoBlockDescriptor(): IBlockDescriptor;
export function headerBigLogoBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function headerBigLogoBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedHeaderBigLogoBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedHeaderBigLogoBlockDescriptor,
    headerBigLogoBlockProperties,
    fieldOrder,
  );
}

export {
  headerBigLogoBlockBlocDefinition,
  headerBigLogoBlockDashboardLayout,
  headerBigLogoBlockProperties,
  headerBigLogoBlockConfig,
  headerBigLogoBlockResolveConfig,
};

export type HeaderBigLogoBlockConfig = typeof headerBigLogoBlockConfig;
